<template>
  <app-layout :title="$t('productMetaTitle.' + this.productKey)" languageSupport='laravel' :languageOvr='language'>
    <template v-slot:header>
      <h1 v-html="pageTitle" />
    </template>

    <div class="container max-w-5xl mx-auto m-8">
      <homepage-box-text-right id="product" :header="$t('productSubtitle.' + productKey)" :images="getProductImages">
        <checked-bullet-point v-for="(item, idx) in $tm('productInfo.' + productKey)" :key="idx">
          <span v-html="item" />
        </checked-bullet-point>
      </homepage-box-text-right>
    </div>

    <div class="roundedBox mx-6 mb-6">
      <span class="text-2xl">{{ $t('totalPrice') }} <strong>{{ $filters.formatCurrency(price) }}</strong></span><br>
      <span class="text-xs px-1 rounded bg-green-800 text-white"><span v-html="$t('availableShippingSee')" /> <a href="/pricing#shipping" v-html="$t('here')" />.</span><br>
      <span class="text-xs" v-html="$t('inclMwSt')" /><br>
      <span class="text-xs" v-html="$t('refundPolicyLink')" />
    </div>

    <div v-if="addons.length > 0" class="roundedBox mx-6 mb-6">
      {{ $t('bookableAddons') }} ({{ $t('selectableLastStep') }})
      <ul class="list-disc list-outside pl-6">
        <li v-for="(addon, idx) in addons" :key="idx">{{ $t(addon.key) }} {{ $filters.formatCurrency(addon.price) }}</li>
      </ul>
    </div>

    <div v-if="shippingOptions.length > 0" class="roundedBox mx-6 mb-6">
      {{ $t('shippingOptions') }} ({{ $t('selectableLastStep') }})
      <ul class="list-disc list-outside pl-6">
        <li v-for="(shippingOption, idx) in shippingOptions" :key="idx">{{ $t(shippingOption.key) }} {{ $filters.formatCurrency(shippingOption.price) }}</li>
      </ul>
      <a href="/pricing#shipping" v-html="$t('detailsSeeHere')" />
    </div>

    <div class="container mx-auto flex flex-wrap pb-12" id="orderDiv">
      <h1 class="w-full my-2 text-5xl font-bold leading-tight text-center text-gray-800">{{ $t('createCardsNow') }}</h1>
      <div class="w-full mb-4">
        <div class="horline"></div>
      </div>
      <card-request-form custom_icon="shopping-cart" custom_button="buyNow" :direct_checkout="productKey" :nof_copies_default="amount" @nofcopieschanged="nofCopiesChanged" />
    </div>

    <big-buttons showHomepageLink="true" />
    <badges />

    <template v-slot:footer>
    </template>
  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import CardRequestForm from '@/Shared/CardRequestForm.vue'
import NewsletterForm from '@/Shared/NewsletterForm.vue'
import HomepageBoxTextRight from '@/Shared/HomepageBoxTextRight.vue'
import AdWrapper from '@/Shared/AdWrapper.vue'
import CheckedBulletPoint from '@/Shared/CheckedBulletPoint.vue'
import Badges from '@/Shared/Badges.vue'
import BigButtons from '@/Shared/BigButtons.vue'

export default
{
  props: ['language', 'productKey', 'amount', 'price', 'addons', 'shippingOptions'],
  data() {
    return {
    }
  },
  computed: {
    getProductImages() {
      if (this.productKey === 'cards')
        return [
          {name: 'cards/cards_std_VIN_' + this.language + '_front', alt: this.$i18n.t('cards'), link: true},
          {name: 'cards/cards_std_VIN_' + this.language + '_back', alt: this.$i18n.t('cards'), link: true},
          {name: 'cards/cards_competition_WHT_' + this.language + '_front', alt: this.$i18n.t('cards'), link: true},
          {name: 'cards/cards_competition_WHT_' + this.language + '_back', alt: this.$i18n.t('cards'), link: true},
          {name: 'cards/cards_box_ROS_' + this.language + '_front', alt: this.$i18n.t('cards'), link: true},
          {name: 'cards/cards_box_ROS_' + this.language + '_back', alt: this.$i18n.t('cards'), link: true},
          {name: 'cards/cards_std_GRN_' + this.language + '_front', alt: this.$i18n.t('cards'), link: true},
          {name: 'cards/cards_std_GRN_' + this.language + '_back', alt: this.$i18n.t('cards'), link: true},
          {name: 'cards/cards_competition_BLU_' + this.language + '_front', alt: this.$i18n.t('cards'), link: true},
          {name: 'cards/cards_competition_BLU_' + this.language + '_back', alt: this.$i18n.t('cards'), link: true},
          {name: 'cards/cards_box_YEL_' + this.language + '_front', alt: this.$i18n.t('cards'), link: true},
          {name: 'cards/cards_box_YEL_' + this.language + '_back', alt: this.$i18n.t('cards'), link: true}
        ];
      else if (this.productKey === 'labels')
        return [
          {name: 'labels/labels_' + this.language, alt: this.$i18n.t('labels'), link: true}
        ];
      return [];
    },
    pageTitle() {
      return this.amount + ' ' + this.$i18n.t('productTitle.' + this.productKey);
    }
  },
  mounted () {
  },
  destroyed () {
  },
  components:
  {
    AppLayout,
    CardRequestForm,
    NewsletterForm,
    HomepageBoxTextRight,
    AdWrapper,
    CheckedBulletPoint,
    Badges,
    BigButtons
  },
  methods:
  {
    nofCopiesChanged(nofCopies)
    {
      window.location.href = '/product/' + this.productKey + '/' + nofCopies;
    }
  },
}
</script>
